/**
 * Check if any of the object's properties are set
 * @param obj Object to test
 * @returns True if any of the object's properties are set
 */
export const areAnyPropsSet = <O extends {}>(obj?: O) =>
	!obj ? false : Object.values(obj).some((filter) => filter != null);
